/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=70e58047"
const script = {}

import exportComponent from "/Users/jianghoufu/Desktop/chain-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__